import { render } from "./selectSurvey.vue?vue&type=template&id=9fac700c"
import script from "./selectSurvey.vue?vue&type=script&lang=js"
export * from "./selectSurvey.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__